import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { clearUserCredentials, getUserId } from './auth';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'include',
});

const createCache = () => {
  const cache = new InMemoryCache();

  if (process.env.NODE_ENV === 'development') {
    window.cacheContainer = cache;
  }

  return cache;
};

let singletonClient;

const errorLink = onError(({ graphQLErrors }) => {
  const isAuthenticated = Boolean(getUserId());

  if (!graphQLErrors || !isAuthenticated) {
    return;
  }

  graphQLErrors.forEach(({ path, extensions }) => {
    const errorCode = extensions?.code;
    const requestedPath = path?.[0];

    if (errorCode === 'AUTHENTICATION_ERROR' && requestedPath !== 'currentUserProfile') {
      clearUserCredentials();
      if (singletonClient) {
        void singletonClient.clearStore().catch(() => {});
      }
      window.alert('Your session has EXPIRED! You will be redirected to login.');
      window.location.href = window.location.origin;
    }
  });
});

export const createClient = () => {
  if (singletonClient) {
    return singletonClient;
  }

  singletonClient = new ApolloClient({
    link: ApolloLink.from([errorLink, httpLink]),
    credentials: 'include', // Ensures cookies are sent
    cache: createCache(),
    addTypename: false,
    connectToDevTools: process.env.NODE_ENV === 'development',
  });

  return singletonClient;
};
